import React from 'react';
import styled from 'styled-components';
import RelativeDay from '../../components/Day/RelativeDay';
import ShowMore from './ShowMore';
import SlotSelectorStates from '../../components/SlotSelectorStates';
import { SupportedLocale } from '../../../../../core/util/localizedStr';
import { isBeyondNextDayAppointmentsEnabled } from '~/core/util/location';

const DayShowMoreContainer = styled.div.withConfig({ componentId: 'sc-m74kf4-0' })`
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto 15px;
`;

const TomorrowContainer = styled.div.withConfig({ componentId: 'sc-m74kf4-1' })`
  margin-top: 20px;
`;

type Props = {
  selectedDate: any;
  location: any;
  modalState?: any;
  futureSlotData: any;
  handleSelectSlot: (...args: any[]) => any;
  nextDate: any;
  selectedSlots: any[];
  setHasOpenedTimeSelectorModal?: (...args: any[]) => any;
  shouldShowWalkInCopy?: boolean;
  isVisible?: boolean;
  handleClickShowMore?: (...args: any[]) => any;
  setAndHandleDate: (...args: any[]) => any;
  locale?: SupportedLocale;
  // Below props are for old booking flow
  shouldSelectFirstSlotAsInitialValue: boolean;
  shouldSetSelectedSlotToFirstVisibleSlot: boolean;
};

const NoSlotsTomorrow = (props: Props) => {
  const {
    location,
    futureSlotData,
    handleSelectSlot,
    nextDate,
    selectedSlots,
    shouldShowWalkInCopy,
    selectedDate,
    isVisible,
    handleClickShowMore,
    setAndHandleDate,
    // Below props are for old booking flow
    shouldSelectFirstSlotAsInitialValue,
    shouldSetSelectedSlotToFirstVisibleSlot,
  } = props;

  if (!isVisible) return null;

  return (
    <TomorrowContainer>
      <DayShowMoreContainer>
        <RelativeDay selectedDate={selectedDate} timeZone={location.timeZone} />
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type '(...ar... Remove this comment to see the full error message */}
        <ShowMore onClick={handleClickShowMore} shouldShowMore={false} />
      </DayShowMoreContainer>

      <SlotSelectorStates
        allowExpandInPlace={false}
        futureSlotData={futureSlotData}
        handleClickShowMore={handleClickShowMore}
        handleSelectSlot={handleSelectSlot}
        location={location}
        nextDate={nextDate}
        selectedDate={selectedDate}
        selectedSlots={selectedSlots}
        setAndHandleDate={setAndHandleDate}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        shouldSetSelectedSlotToFirstVisibleSlot={shouldSetSelectedSlotToFirstVisibleSlot}
        shouldShowNextAvailableAppointmentCta={isBeyondNextDayAppointmentsEnabled(location)}
        shouldShowWalkInCopy={shouldShowWalkInCopy}
      />
    </TomorrowContainer>
  );
};

export default NoSlotsTomorrow;
